import React from 'react';
import { useTranslation } from 'react-i18next';
import { AlertTriangle } from 'lucide-react';

function ActionStrip({ alerts }) {
  const { t } = useTranslation('common');

  if (!alerts || alerts.length === 0) return null;

  return (
    <div className="mb-6 rounded-xl border border-amber-200 bg-amber-50 p-4">
      <h2 className="text-sm font-semibold text-amber-800 mb-3 flex items-center gap-2">
        <AlertTriangle size={16} />
        {t('dashboard.attention.title')}
      </h2>
      <ul className="space-y-2">
        {alerts.map((item) => (
          <li key={item.id} className="flex items-center justify-between gap-4 text-sm text-amber-900">
            <span>{item.headline}</span>
            {item.actions && item.actions.length > 0 && (
              <div className="flex items-center gap-2 flex-shrink-0">
                {item.actions.map((action) => (
                  <button
                    key={action.id}
                    type="button"
                    onClick={() => window.alert(t('dashboard.attention.comingSoon'))}
                    className="text-xs font-semibold text-amber-700 underline underline-offset-2 hover:no-underline"
                  >
                    {action.label}
                  </button>
                ))}
              </div>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default ActionStrip;